import { dataAtom, dataComposer } from "@frend-digital/centra-legacy";

import { baseAtomics } from "@/lib/centra/atomicSetup";
import type { CentraProduct } from "../../atomicSetup";
import {
  getComingSoon,
  getLabels,
  getOnlineExclusive,
  getPreorder,
  getPreorderDate,
  getSaleProductTagDisplayStatus,
  getSoldOut,
  getType,
} from "../../localAtomics";
import getProductCore from "./getCore";
import getProductDescription from "./getDescription";
import getProductGallery from "./getGallery";

const { getProduct, getSku, getProductBreadcrumbs, getProductSku } =
  baseAtomics;

const formatProductCard = (product: CentraProduct) => {
  const core = getProductCore(product);
  const id = dataAtom(getProduct, 2)(product);
  const gallery = getProductGallery(product);
  const description = getProductDescription(product);
  const comingSoon = dataAtom(getComingSoon, 2)(product);
  const preorder = dataAtom(getPreorder, 2)(product);
  const preorderDate = dataAtom(getPreorderDate, 2)(product);
  const onlineExclusive = dataAtom(getOnlineExclusive, 2)(product);
  const labels = dataAtom(getLabels, 2)(product);
  const soldOut = dataAtom(getSoldOut, 2)(product);
  const sku = dataAtom(getSku, 2)(product);
  const productSku = dataAtom(getProductSku, 2)(product);
  const breadcrumbs = dataAtom(getProductBreadcrumbs, 2)(product);
  const type = dataAtom(getType, 2)(product);
  const displayPercentOrSale = dataAtom(
    getSaleProductTagDisplayStatus,
    2,
  )(product);

  const bookletProductCard = dataComposer({
    core,
    gallery,
    soldOut,
    comingSoon,
    preorder,
    preorderDate,
    onlineExclusive,
    labels,
    description,
    id,
    breadcrumbs,
    sku,
    productSku,
    type,
    displayPercentOrSale,
  });
  return {
    ...bookletProductCard.data,
    depictListingResultId: undefined as undefined | string,
    depictSearchResultId: undefined as undefined | string,
    depictProductId: undefined as undefined | string,
  };
};

// export const getProductCardData = (product: CentraProduct) =>
//   formatProductCard(product)["data"];

export default formatProductCard;

export type ProductCard = ReturnType<typeof formatProductCard>;
